export { default as MovieDetailCardWithPoster_1 } from "./MovieDetailCardWithPoster_1";
